import { END_POINTS } from '../helpers';
import { EngineCapacityData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetEngineCapacityResponse = {
  count: number;
  data: EngineCapacityData[];
};

export const gccApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getEngineCapacity: builder.query<
      CommonResponse & { data: GetEngineCapacityResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getEngineCapacity}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteEngineCapacity: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteEngineCapacity}/${id}`,
        method: 'DELETE',
      }),
    }),
    getEngineCapacityById: builder.query<
      CommonResponse & { data: EngineCapacityData },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getEngineCapacityById}/${id}`,
        method: 'GET',
      }),
    }),

    addEngineCapacity: builder.mutation<
      CommonResponse & { data: EngineCapacityData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addEngineCapacity}`,
        method: 'POST',
        body,
      }),
    }),
    updateEngineCapacity: builder.mutation<
      CommonResponse & { data: EngineCapacityData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateEngineCapacity}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddEngineCapacityMutation,
  useUpdateEngineCapacityMutation,
  useLazyGetEngineCapacityQuery,
  useLazyDeleteEngineCapacityQuery,
  useLazyGetEngineCapacityByIdQuery,
} = gccApi;
